import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Iter 268 — QR-menukaart laadt enkel de lichte publieke bundle; de volledige
// app (auth, dashboards, HACCP, IoT …) wordt daar nooit gedownload.
if (/^\/menu\/[^/]+\/?$/.test(window.location.pathname)) {
  import("@/PublicMenuEntry").then(({ default: PublicMenuEntry }) => {
    root.render(
      <React.StrictMode>
        <PublicMenuEntry />
      </React.StrictMode>,
    );
  });
} else {
  Promise.all([import("@/App"), import("@tanstack/react-query")]).then(
    ([{ default: App }, { QueryClient, QueryClientProvider }]) => {
      const queryClient = new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60_000,
            refetchOnWindowFocus: false,
          },
        },
      });
      root.render(
        <React.StrictMode>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </React.StrictMode>,
      );
    },
  );
}
